import Requester from "./utils/Requester";

const alfredoAPIRequester = new Requester(`${process.env.GATSBY_BACKEND}`);
//const alfredoAPIRequester = new Requester(`https://v2.sys.alfredo.pt`);

export { alfredoAPIRequester };
